import PhotographerCalendarApi from '../PhotographerCalendarApi';
import ICalendar from '../../calendar/ICalendar';
import * as types from './ActionTypes';
import DateHelper from '../../../shared/DateHelper';

function getPhotographersByRegionSuccess(result: any) {
    return { type: types.GET_PHOTOGRAPHERS_BY_REGION_SUCCESS, result };
}

export function getPhotographersByRegion() {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.getPhotographersByRegion().then((result: any) => {
            dispatch(getPhotographersByRegionSuccess(result));
        });
    };
}

function getMultiplePhotographerCalendarsSuccess(result: any) {
    return { type: types.GET_MULTIPLE_CALENDARS_SUCCESS, result };
}

export function getMultiplePhotographerCalendars(ids: number[], from: any, to: any) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.getPhotographerCalendars(ids, from, to).then(
            (result: any) => {
                dispatch(getMultiplePhotographerCalendarsSuccess(result));
            }
        );
    };
}

function deletePhotographerCalendarItemSuccess(result: any) {
    return { type: types.DELETE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS, result };
}

function updatePhotographerCalendarItemSuccess(result: any) {
    return { type: types.UPDATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS, result };
}

export function updatePhotographerCalendarItem(calendarItem: any) {
    let x = calendarItem;
    let item = {
        id: isNaN(Number(x.id)) ? undefined : x.id,
        orderId: x.orderId,
        title: x.title,
        description: x.description,
        type: x.type,
        start: x.start,
        end: x.end,
        userId: x.userId,
        photographerId: x.photographerId || x.userId
    };

    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.updatePhotographerCalendarItem(item).then((result) => {
            dispatch(updatePhotographerCalendarItemSuccess(item));
        });
    };
}

function createPhotographerCalendarItemSuccess(result: any) {
    return { type: types.CREATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS, result };
}

export function createPhotographerCalendarItem(calendarItem: any) {
    let x = calendarItem;
    let item = {
        id: isNaN(Number(x.id)) ? undefined : x.id,
        orderId: x.orderId,
        title: x.title,
        description: x.description,
        type: x.type,
        start: x.start,
        end: x.end,
        userId: x.userId,
        photographerId: x.photographerId
    };

    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.createPhotographerCalendarItem(item).then((result) => {
            result.item = item;
            dispatch(createPhotographerCalendarItemSuccess(result));
        });
    };
}

export function deletePhotographerCalendarItem(calendarItem: any) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.deletePhotographerCalendarItem(calendarItem).then(
            (result) => {
                dispatch(deletePhotographerCalendarItemSuccess(calendarItem));
            }
        );
    };
}

function updatePhotographerCalendarWorkingHoursSuccess(result: any) {
    return {
        type: types.UPDATE_PHOTOGRAPHER_CALENDAR_WORKING_HOURS_SUCCESS,
        result
    };
}

export function updatePhotographerCalendarWorkingHours(
    userId: number,
    se360WorkingHours: any[],
    scandphotosWorkingHours: any[]
) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.updatePhotographerCalendarWorkingHours(
            userId,
            se360WorkingHours,
            scandphotosWorkingHours
        ).then((result) => {
            se360WorkingHours = se360WorkingHours.map((x) => {
                x.userId = userId;
                return x;
            });

            scandphotosWorkingHours = scandphotosWorkingHours.map((x) => {
                x.userId = userId;
                return x;
            });

            dispatch(
                updatePhotographerCalendarWorkingHoursSuccess({
                    se360WorkingHours: se360WorkingHours,
                    scandphotosWorkingHours: scandphotosWorkingHours
                })
            );
        });
    };
}

export function createSms(toPhoneNumber: string, body: string, desiredSendTime?: Date) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.createSmsToPhotographer(
            toPhoneNumber,
            body,
            desiredSendTime
        );
    };
}

function getSmsTemplatesSuccess(result: any) {
    return { type: types.GET_SMS_TEMPLATES_FOR_PHOTOGRAPHER, result };
}

export function getSmsTemplates(photographerId: number) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.getSmsTemplates(photographerId).then((result) => {
            dispatch(getSmsTemplatesSuccess(result));
        });
    };
}

export function createEmail(fromEmail, toEmail, subject, body, cc, desiredSendTime) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.createEmailToPhotographer(
            fromEmail,
            toEmail,
            subject,
            body,
            cc,
            desiredSendTime
        );
    };
}

function getEmailTemplatesSuccess(result: any) {
    return { type: types.GET_EMAIL_TEMPLATES_FOR_PHOTOGRAPHER, result };
}

export function getEmailTemplates(photographerId: number) {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.getEmailTemplates(photographerId).then((result) => {
            dispatch(getEmailTemplatesSuccess(result));
        });
    };
}

function getEmailSendersSuccess(result: any) {
    return { type: types.GET_EMAIL_SENDERS_FOR_PHOTOGRAPHER, result };
}

export function getEmailSenders() {
    return function (dispatch: (result: any) => void) {
        return PhotographerCalendarApi.getEmailSenders().then((result) => {
            dispatch(getEmailSendersSuccess(result));
        });
    };
}
